module.exports = __webpack_public_path__ + "img/qr-icon.39629214.svg";